import React, { useEffect, useState } from "react";
import "./styles.scss";
import { Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import PageHeader from "../../../../dashboard/components/page-header/PageHeader";
import { useFirestore } from "reactfire";
import { Mentor } from "../mentor-profiles/MentorProfiles";
// @ts-ignore
import renderHTML from "react-render-html";

const MentorProfile = () => {
  const { id } = useParams() as any;
  const store = useFirestore();
  const [mentor, setMemntor] = useState<Mentor>({
    id: "",
    bio: "",
    photoURL: "",
    fullName: "",
    qualification: "",
    designation: "",
    createdAt: new Date(),
    countries: [],
  });

  useEffect(() => {
    store
      .collection("mentors")
      .doc(id)
      .get({ source: "cache" })
      .then((doc) => {
        setMemntor((ps) => ({ ...(doc.data() as any) }));
      });
  }, [store, id]);

  return (
    <div>
      <PageHeader showBackButton={true} title="Mentor Profile" />
      <Container
        fluid
        style={{
          paddingTop: "200px",
          paddingLeft: "50px",
          paddingRight: "50px",
        }}
      >
        <Row>
          <Col xs={12} className="mentor-profile-wrapper">
            <div className="image-wrapper">
              <img src={mentor.photoURL} alt="" />
              <div>
                <label>
                  {mentor.fullName +
                    (mentor.qualification ? ", " + mentor.qualification : "")}
                </label>
                <label style={{ fontSize: "12px" }}>{mentor.designation}</label>
              </div>
            </div>
            <div className="biograpy text-justify">
              {mentor.bio && mentor.bio.length > 7 && <label>BIOGRAPY</label>}
              {renderHTML(mentor.bio)}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default MentorProfile;
